import * as React from "react";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../../../helper/Toast";
import CreateBrandFormView from "./CreateBrandFormView";
import Brand from "../../../../../model/brand/Brand";
import {createBrand} from "../../../../../store/action/brand/brand";
import {none, option, Option} from "ts-option";
import Address from "../../../../../model/address/Address";

interface IComponentProps {
	/**
	 * On successful created brand callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

interface IDispatchProps {
	/**
	 * Create brand.
	 * @param {brand} brand
	 * @param {Option<File>} brand logo
	 * @param {Option<Address>} address
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createBrand: (brand: Brand, file: Option<File>, address: Option<Address>, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Brand logo file.
	 */
	file: Option<File>
}

type Props = IComponentProps & IDispatchProps

class CreateBrandForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false, file: none};
		this.onSubmit = this.onSubmit.bind(this);
		this.onAddFile = this.onAddFile.bind(this);
	}

	render() {
		return (
			<CreateBrandFormView onSubmit={this.onSubmit}
								 onCancel={this.props.onCancel}
								 isSubmitting={this.state.isSubmitting}
								 onAddFile={this.onAddFile}
								 onRemoveFile={() => this.setState({file: none})}/>
		);
	}

	onAddFile(file: File) {
		this.setState({file: option(file)})
	}

	onSubmit(data: Brand, address: Option<Address>) {
		this.setState({isSubmitting: true}, () => {
			this.props.createBrand(
				data,
				this.state.file,
				address,
				() => {
					Toast.success("Brand created", "Brand create");
					this.props.onSuccess();
				},
				(error: any) => {
					let err: string;
					if (error && error.response && error.response.status == 409)
						err = `Brand with name '${data.name}' exists`;
					else
						err = "Brand create failed";
					this.setState({isSubmitting: false}, () => Toast.error(err, "Brand create"));
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createBrand: (brand: Brand, file: Option<File>, address: Option<Address>, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createBrand(brand, file, address, onSuccess, onFailure))
	};
}

export default connect<null, IDispatchProps, IComponentProps>(null, mapDispatchToProps)(CreateBrandForm);